import { Routes } from '@angular/router';
import { DashboardComponent } from './components/hrwe-tpl/dashboard/dashboard.component';
import { AuthGuardService } from './services/authGuard.service';
import { LoginComponent } from './components/hrwe-tpl/login/login.component';
import { RegistrationEmailConfirmComponent } from './components/hrwe-tpl/registration/registration-email-confirm/registration-email-confirm.component';
import { RegistrationComponent } from './components/hrwe-tpl/registration/registration/registration.component';
import { PersonalDetailComponent } from './components/hrwe-tpl/registration/personalDetail/personalDetail.component';
import { CompanyDetailComponent } from './components/hrwe-tpl/registration/companyDetail/companyDetail.component';
import { SummaryComponent } from './components/hrwe-tpl/registration/summary/summary.component';
import { UserListComponent } from './components/hrwe-tpl/user/user-list/user-list.component';
import { UserDetailComponent } from './components/hrwe-tpl/user/user-detail/user-detail.component';
import { DashboardLayoutComponent } from './components/hrwe-tpl/dashboard-layout/dashboard-layout.component';
import { ContractSignIntroductionComponent } from './components/hrwe-tpl/registration/contract-sign/contract-sign-introduction/contract-sign-introduction.component';
import { ContractSignSigningProcessComponent } from './components/hrwe-tpl/registration/contract-sign/contract-sign-signing-process/contract-sign-signing-process.component';
import { ContractSignSuccessComponent } from './components/hrwe-tpl/registration/contract-sign/contract-sign-success/contract-sign-success.component';
import { RegisterLayoutComponent } from './components/hrwe-tpl/register-layout/register-layout.component';
import { ProfilePersonalComponent } from './components/hrwe-tpl/profile/profile-personal/profile-personal.component';
import { ProfileCompanyComponent } from './components/hrwe-tpl/profile/profile-company/profile-company.component';
import { ProfileContractComponent } from './components/hrwe-tpl/profile/profile-contract/profile-contract.component';
import { BlankComponent } from './custom-pages/blank/blank.component';
import { NewReportRequestComponent } from './components/hrwe-tpl/report/new-report-request/new-report-request.component';
import { NewReportListComponent } from './components/hrwe-tpl/report/new-report-list/new-report-list.component';
import { NewReportDetailComponent } from './components/hrwe-tpl/report/new-report-detail/new-report-detail.component';
import { CandidateEntryComponent } from './components/hrwe-tpl/report/candidate-entry/candidate-entry.component';
import { ResetPasswordComponent } from './components/hrwe-tpl/reset-password/reset-password.component';
import { ListConfigComponent } from './components/hrwe-tpl/config/list-config/list-config.component';
import { CreateConfigComponent } from './components/hrwe-tpl/config/create-config/create-config.component';
import { ManageConfigComponent } from './components/hrwe-tpl/config/manage-config/manage-config.component';
import { CandidateListComponent } from './components/hrwe-tpl/report/candidate-list/candidate-list.component';
import { ListAssistenzaComponent } from './components/hrwe-tpl/assistenza/list-assistenza/list-assistenza.component';
import { CreateAssistenzaComponent } from './components/hrwe-tpl/assistenza/create-assistenza/create-assistenza.component';
import { ManageAssistenzaComponent } from './components/hrwe-tpl/assistenza/manage-assistenza/manage-assistenza.component';
import { ListDocumentComponent } from './components/hrwe-tpl/document/list-document/list-document.component';
import { ManageDocumentComponent } from './components/hrwe-tpl/document/manage-document/manage-document.component';
import { CreateDocumentComponent } from './components/hrwe-tpl/document/create-document/create-document.component';
import { ListRegisterPaymentComponent } from './components/hrwe-tpl/payment/list-register-payment/list-register-payment.component';
import { ListBillPaymentComponent } from './components/hrwe-tpl/payment/list-bill-payment/list-bill-payment.component';
import { BillDetailComponent } from './components/hrwe-tpl/payment/bill-detail/bill-detail.component';
import { AdminDetailComponent } from './components/hrwe-tpl/profile/admin-detail/admin-detail.component';
import { CandidateDetailComponent } from './components/hrwe-tpl/report/candidate-detail/candidate-detail.component';
import { CandidatePrivacyComponent } from './components/hrwe-tpl/report/candidate-privacy/candidate-privacy.component';
import { CandidateSuccessComponent } from './components/hrwe-tpl/report/candidate-success/candidate-success.component';
import { NewVisuraRequestComponent } from './components/hrwe-tpl/report/new-visura-request/new-visura-request.component';

export const AppRoutes: Routes = [

  { path: '', pathMatch: 'full', component: LoginComponent },
  {
    path: '',
    component: RegisterLayoutComponent,
    children: [
      { path: 'intro-registrazione', pathMatch: 'full', component: RegistrationComponent },
      { path: 'registrazione/:activationCode', component: RegistrationEmailConfirmComponent },
      { path: 'registrazione/:registerId/personalDetail', pathMatch: 'full', component: PersonalDetailComponent },
      { path: 'registrazione/:registerId/companyDetail', pathMatch: 'full', component: CompanyDetailComponent },
      { path: 'registrazione/:registerId/summary', pathMatch: 'full', component: SummaryComponent },
      { path: 'registrazione/:registerId/contract/intro', pathMatch: 'full', component: ContractSignIntroductionComponent },
      { path: 'registrazione/:registerId/contract/sign', pathMatch: 'full', component: ContractSignSigningProcessComponent },
      { path: 'registrazione/:registerId/contract/success', pathMatch: 'full', component: ContractSignSuccessComponent },
      { path: 'report/:requestNumber/:uuid', pathMatch: 'full', component: CandidatePrivacyComponent },
      { path: 'report/:requestNumber/:uuid/entry', pathMatch: 'full', component: CandidateEntryComponent },
      { path: 'report/:requestNumber/:uuid/success', pathMatch: 'full', component: CandidateSuccessComponent },
      { path: 'reset/password/:activationCode', component: ResetPasswordComponent }
    ]
  },
  {
    path: '',
    component: DashboardLayoutComponent,
    canActivate: [AuthGuardService],
    children: [
      { path: 'home', pathMatch: 'full', component: DashboardComponent },
      { path: 'user', pathMatch: 'full', component: UserListComponent },
      { path: 'user/detail/:clientId', pathMatch: 'full', component: UserDetailComponent },
      { path: 'admin/personal', pathMatch: 'full', component: AdminDetailComponent },
      { path: 'admin/password', pathMatch: 'full', component: ResetPasswordComponent },
      { path: 'profile/personal', pathMatch: 'full', component: ProfilePersonalComponent },
      { path: 'profile/company', pathMatch: 'full', component: ProfileCompanyComponent },
      { path: 'profile/contract', pathMatch: 'full', component: ProfileContractComponent },
      { path: 'profile/password', component: ResetPasswordComponent },
      { path: 'help', pathMatch: 'full', component: ListAssistenzaComponent },
      { path: 'help/create', pathMatch: 'full', component: CreateAssistenzaComponent },
      { path: 'help/detail/:id', pathMatch: 'full', component: ManageAssistenzaComponent },
      { path: 'report/create-new-visura', pathMatch: 'full', component: NewVisuraRequestComponent },
      { path: 'report/create-new-report', pathMatch: 'full', component: NewReportRequestComponent },
      { path: 'report/report-history', pathMatch: 'full', component: NewReportListComponent },
      { path: 'report/detail/view/:requestNumber', pathMatch: 'full', component: NewReportDetailComponent },
      { path: 'report/candidate-list', pathMatch: 'full', component: CandidateListComponent },
      { path: 'report/:requestNumber/candidate/detail/:uuid', pathMatch: 'full', component: CandidateDetailComponent },
      { path: 'consumption/month', pathMatch: 'full', component: ListRegisterPaymentComponent},
      { path: 'consumption/unpaid', pathMatch: 'full', component: ListRegisterPaymentComponent },
      { path: 'consumption/all', pathMatch: 'full', component: ListRegisterPaymentComponent },
      { path: 'consumption/bill', pathMatch: 'full', component: ListBillPaymentComponent },
      { path: 'consumption/bill/detail/:id', pathMatch: 'full', component: BillDetailComponent },
      { path: 'file/list', pathMatch: 'full', component: ListDocumentComponent},
      { path: 'file/create', pathMatch: 'full', component: CreateDocumentComponent },
      { path: 'file/detail/:id', pathMatch: 'full', component: ManageDocumentComponent },
      { path: 'file/download', pathMatch: 'full', component: BlankComponent },
      { path: 'tenant', pathMatch: 'full', component: ListConfigComponent },
      { path: 'tenant/create-tenant', pathMatch: 'full', component: CreateConfigComponent },
      { path: 'tenant/manage-tenant/:id', pathMatch: 'full', component: ManageConfigComponent }
    ]
  }

  /* {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },{
    path: '',
    component: MainComponent,
    children: [{
      path: 'dashboard',
      loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule)
    },{
      path: 'emails',
      loadChildren: () => import('./emails/emails.module').then(m => m.EmailsModule)
    },{
      path: 'chat',
      loadChildren: () => import('./chat/chat.module').then(m => m.ChatModule)
    },{
      path: 'features',
      loadChildren: () => import('./features/features.module').then(m => m.FeaturesModule)
    },{
      path: 'components',
      loadChildren: () => import('./components/components.module').then(m => m.ComponentsModule)
    },{
      path: 'icons',
      loadChildren: () => import('./icons/icons.module').then(m => m.IconsModule)
    },{
      path: 'cards',
      loadChildren: () => import('./cards/cards.module').then(m => m.CardsModule)
    },{
      path: 'forms',
      loadChildren: () => import('./forms/forms.module').then(m => m.FormsDemoModule)
    },{
      path: 'tables',
      loadChildren: () => import('./tables/tables.module').then(m => m.TablesDemoModule)
    },{
      path: 'data-tables',
      loadChildren: () => import('./data-tables/datatables.module').then(m => m.DataTablesDemoModule)
    },{
      path: 'chart',
      loadChildren: () => import('./chart/charts.module').then(m => m.ChartsDemoModule)
    },{
      path: 'maps',
      loadChildren: () => import('./maps/maps.module').then(m => m.MapsDemoModule)
    },{
      path: 'pages',
      loadChildren: () => import('./custom-pages/pages.module').then(m => m.PagesDemoModule)
    },{
      path: 'user-pages',
      loadChildren: () => import('./user-pages/users.module').then(m => m.UsersModule)
    },{
      path: 'calendar',
      loadChildren: () => import('./calendar/calendar.module').then(m => m.CalendarDemoModule)
    },{
      path: 'media',
      loadChildren: () => import('./media/media.module').then(m => m.MediaModule)
    },{
      path: 'editor',
      loadChildren: () => import('./editor/editor.module').then(m => m.EditorDemoModule)
    }]
  }, {
    path: '',
    component: AuthLayoutComponent,
    children: [{
      path: 'authentication',
      loadChildren: () => import('./session/session.module').then(m => m.SessionModule)
    },{
      path: 'error',
      loadChildren: () => import('./error/error.module').then(m => m.ErrorModule)
    }]
  } */
];

